import React from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

// Learning
// To best leverage Stripe’s advanced fraud functionality,
// include this script on every page, not just the checkout page.
// This allows Stripe to detect anomalous behavior that may be indicative
// of fraud as customers browse your website.
// Note: This is why we are adding it to a Layout component.

const stripePromise = loadStripe("pk_live_EmX4IvdhprstywydBYZwJKUu00KE5Mk5xl");
//const stripePromise = loadStripe("pk_test_51GsGirDnh9rPyxqUsozCVDhWCLcKgopWoPXXtmmCzCiWZvfkSqdFeR9R9EiyACoJovUFJXIRMdH4lA9qwC343O7700JIV0yn0u");

// TIP
// call loadStripe outside of a component
// in that way there's no chance it will get
// called more times than it needs to

const Layout = ({ children }) => {
  return (
    <>
      <Elements stripe={stripePromise}>{children}</Elements>
    </>
  );
};

export default Layout;
